import { CircularProgress } from "@chakra-ui/react";
import {
  Drawer,
  Box,
  Typography,
  Button,
  TextField,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isAdmin } from "../../utils/sectionPermissions";
import styles from "./AdminProducts.module.css";
import ReadMoreReadLess from "react-read-more-read-less";
import { Image, Heading, Text } from "@chakra-ui/react";
import { Form } from "react-bootstrap";
import ReactSelect from "react-select";
import MarketPlaceDetails from "./MarketPlaceDetail/MarketPlaceDetails.js";
import DynamicDialog from "../../store/DynamicDialog/DynamicDialog.tsx";
import { toast } from "react-toastify";


// type2 rows can be an array or a JSON-encoded string; `.join` crashed on the
// latter. Normalise to the comma string the tags input edits.
const tagString = (t) => {
  let list = t;
  if (typeof list === "string") {
    try {
      list = JSON.parse(list);
    } catch (e) {
      return list;
    }
  }
  return Array.isArray(list) ? list.join(",") : "";
};

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 224,
      width: 250,
    },
  },
};

function AdminProducts(props) {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [createItems, setCreateItems] = useState([]);
  const [disabledItems, setDisabledItems] = useState([]);
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [companies, setCompanies] = useState([]);
  const [companyId, setCompanyId] = useState("");
  const [selectedCompany, setSelectedCompany] = useState("");
  const [openCompanyDrawer, setOpenCompanyDrawer] = useState(false);
  const [newCompany, setNewCompany] = useState("");
  const [vendorName, setVendorName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [tags, setTags] = useState("");
  const [logoLink, setLogoLink] = useState("");
  const [info, setInfo] = useState("");
  const [mainEmail, setMainEmail] = useState("");
  const [billingEmail, setBillingEmail] = useState("");
  const [billingType, setBillingType] = useState("monthly");
  const [netPayment, setNetPayment] = useState("30");
  const [status, setStatus] = useState("Active");
  const [showAddForm, setAddFormShow] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [triggerMarketPlace, setTriggerMarketPlace] = useState(false);
  const [selectedMarketPlace, setSelectedMarketPlace] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [showRemoveDialog, setShowRemoveDialog] = useState(false);
  const [removeId, setRemoveId] = useState(null);
  const [showDuplicateDialog, setShowDuplicateDialog] = useState(false);
  const [duplicateId, setDuplicateId] = useState(null);
  const [postLoader, setPostLoader] = useState(false);
  const [itemVendorId, setItemVenodrId] = useState(null);
  const adminVendorId = -1;

  //LOADER:
  const [marketPlaceLoader, setMarketPlaceLoader] = useState(false);
  const [editSubmitLoader, setEditSubmitLoader] = useState(false);
  const [addFormSubmitLoader, setAddSubmitLoader] = useState(false);
  const [skuId, setSkuId] = useState(null);

  const [errors, setErrors] = useState({
    name: "",
    logoLink: "",
    tags: "",
    info: "",
  });

  const [search, setSearch] = useState("");
  const [isExisting, setIsExisting] = useState(false);

  // Category + Sub Category
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [openCategoryDrawer, setOpenCategoryDrawer] = useState(false);
  const [openSubCategoryDrawer, setOpenSubCategoryDrawer] = useState(false);
  const [newCategory, setNewCategory] = useState("");
  const [newSubCategory, setNewSubCategory] = useState("");
  const [newSubCategoryCat, setNewSubCategoryCat] = useState(null);

  // Admin popularity boost (0-100). 30% weight in customer popularity sort.
  const [adminPopularityBoost, setAdminPopularityBoost] = useState(50);

  // USEEFFECT
  useEffect(() => {
    setMarketPlaceLoader(true);
    fetch(
      `${process.env.REACT_APP_SERVER_URL}/admin/marketplace/get_admin_products`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "include",
        method: "GET",
      },
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 201) {
          console.log("DATA NOT FETCHED");
        } else if (response.status === 202) {
          navigate("/login");
        }
      })
      .then((data) => {
        setItems(data);
        setMarketPlaceLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setMarketPlaceLoader(false);
      });
    fetch(
      `${process.env.REACT_APP_SERVER_URL}/admin/marketplace/get_products_to_create`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "include",
        method: "GET",
      },
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 201) {
          console.log("DATA NOT FETCHED");
        } else if (response.status === 202) {
          navigate("/login");
        }
      })
      .then((data) => {
        setCreateItems(data.data);
        setDisabledItems(data.mp_v);
      })
      .catch((err) => {
        console.log(err);
      });
    fetch(`${process.env.REACT_APP_SERVER_URL}/get_company`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      method: "GET",
    })
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 201) {
          console.log("DATA NOT FETCHED");
        } else if (response.status === 202) {
          navigate("/login");
        }
      })
      .then((data) => {
        setCompanies(data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    fetch(`${process.env.REACT_APP_SERVER_URL}/get_all_categories`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      method: "GET",
    })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (data?.data) setCategories(data.data);
      })
      .catch((err) => console.log(err));
    fetch(`${process.env.REACT_APP_SERVER_URL}/get_all_subcategories`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      method: "GET",
    })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (data?.data) setSubCategories(data.data);
      })
      .catch((err) => console.log(err));
  }, [triggerMarketPlace, navigate]);

  const addFormOpenHandler = () => {
    setName("");
    setVendorName("Easexpense");
    setStartDate(new Date().toLocaleDateString("en-CA"));
    setMainEmail("lakhendra@easexpense.com");
    setBillingEmail("lakhendra@easexpense.com");
    setBillingType("monthly");
    setNetPayment("30");
    setStatus("Active");
    setLogoLink("");
    setInfo("");
    setTags("");
    setSearch("");
    setSelectedCompany(null);
    setSelectedCategory(null);
    setSelectedSubCategory(null);
    setAdminPopularityBoost(50);
    setSkuId(null);
    setAddFormShow(true);
  };

  const addFormCloseHandler = () => {
    setAddFormShow(false);
    setAddSubmitLoader(false);
  };
  const editFormOpenHandler = (item) => {
    setId(item.id);
    setName(item.name);
    setLogoLink(item.logoLink);
    setInfo(item.info);
    setVendorName(item.vendor_name);
    setMainEmail(item.main_email);
    setBillingEmail(item.billing_email);
    setBillingType(item.billing_type);
    setNetPayment(item.net_payment);
    setStatus(item.status);
    setStartDate(formatDate(item.start_date));
    setTags(tagString(item.type2));
    setSelectedCompany(item.company_id);
    setItemVenodrId(item.vendor_id);
    setSelectedCategory(
      categories.find((c) => c.id === item.category_id) || null,
    );
    setSelectedSubCategory(
      subCategories.find((s) => s.id === item.sub_category_id) || null,
    );
    setAdminPopularityBoost(
      Number.isFinite(Number(item.admin_popularity_boost))
        ? Number(item.admin_popularity_boost)
        : 50,
    );
    setSkuId(null);
    setShowEditForm(true);
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  const editFormCloseHandler = () => {
    setEditSubmitLoader(false);
    setShowEditForm(false);
  };

  const validate = () => {
    const newErrors = {};
    if (!name.trim()) newErrors.name = "Product name is required";
    if (!logoLink.trim()) newErrors.logoLink = "Logo link is required";
    if (!tags.trim()) newErrors.tags = "Tags are required";
    if (!info.trim()) newErrors.info = "Description is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) {
      toast.error("All fields are required");
      return;
    }
    setAddSubmitLoader(true);
    fetch(
      `${process.env.REACT_APP_SERVER_URL}/admin/marketplace/create_admin_products`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "include",
        method: "POST",
        body: JSON.stringify({
          name: name,
          vendor_name: vendorName,
          start_date: startDate,
          main_email: mainEmail,
          billing_email: billingEmail,
          billing_type: billingType,
          net_payment: netPayment,
          type2: tags?.split(","),
          logoLink: logoLink,
          info: info,
          status: status,
          company_id: selectedCompany === "" ? null : selectedCompany,
          category_id: selectedCategory?.id ?? null,
          sub_category_id: selectedSubCategory?.id ?? null,
          admin_popularity_boost: Number(adminPopularityBoost) || 0,
          isExisting: isExisting,
          skuId: skuId,
          vendor_id: adminVendorId,
        }),
      },
    )
      .then((response) => {
        if (response.status === 200) {
          toast.success("Added product successfully");
          setAddSubmitLoader(false);
          setTriggerMarketPlace(!triggerMarketPlace);
          addFormCloseHandler();
          return response.json();
        } else if (response.status === 201) {
          toast.error("Failed to add product");
          setAddSubmitLoader(false);
          setTriggerMarketPlace(!triggerMarketPlace);
        } else if (response.status === 202) {
          navigate("/login");
        }
      })
      .catch((err) => {
        console.log(err);
        setAddSubmitLoader(false);
        setTriggerMarketPlace(!triggerMarketPlace);
      });
  };

  const editSubmitHandler = (e) => {
    e.preventDefault();
    if (!validate()) {
      toast.error("All fields are required");
      return;
    }
    setEditSubmitLoader(true);
    fetch(`${process.env.REACT_APP_SERVER_URL}/admin/marketplace/update`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      method: "POST",
      body: JSON.stringify({
        id: id,
        name: name,
        vendor_name: vendorName,
        start_date: startDate,
        main_email: mainEmail,
        billing_email: billingEmail,
        billing_type: billingType,
        net_payment: netPayment,
        type2: tags?.split(","),
        logoLink: logoLink,
        info: info,
        status: status,
        company_id: selectedCompany === "" ? null : selectedCompany,
        category_id: selectedCategory?.id ?? null,
        sub_category_id: selectedSubCategory?.id ?? null,
        admin_popularity_boost: Number(adminPopularityBoost) || 0,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          toast.success("Edited product successfully");
          setEditSubmitLoader(false);
          setTriggerMarketPlace(!triggerMarketPlace);
          editFormCloseHandler();
        } else if (response.status === 201) {
          toast.error("Something went wrong");
          setEditSubmitLoader(false);
          setTriggerMarketPlace(!triggerMarketPlace);
        } else if (response.status === 202) {
          navigate("/login");
        } else if (response.status === 400) {
          // e.g. sub-category not in the chosen category.
          response
            .json()
            .then((body) => toast.error(body?.msg || "Invalid product details"))
            .catch(() => toast.error("Invalid product details"));
          setEditSubmitLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setEditSubmitLoader(false);
        setTriggerMarketPlace(!triggerMarketPlace);
      });
  };

  const handleSelectMarketPlace = (item) => {
    setSelectedMarketPlace(item);
  };
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const handlePaymentStatusChange = (event) => {
    setPaymentStatus(event.target.value);
  };

  const filteredAppsData = items.filter((key) => {
    const matchesSearchQuery =
      searchQuery === "" ||
      key.name.toLowerCase().includes(searchQuery.toLowerCase());

    const matchesPaymentStatus =
      paymentStatus === "" ||
      (paymentStatus === "Active" && key.status === "Active") ||
      (paymentStatus === "Out Of Stock" && key.status === "Out Of Stock") ||
      (paymentStatus === "Inactive" && key.status === "Inactive");

    const matchesCompanyValue =
      companyId === "" || companyId === key.company_id;
    return matchesSearchQuery && matchesPaymentStatus && matchesCompanyValue;
  });


  const removeHandlerClicked = (id) => {
    setShowRemoveDialog(true);
    setRemoveId(id);
  };

  const handleRemoveInvite = async () => {
    setPostLoader(true);
    fetch(
      `${process.env.REACT_APP_SERVER_URL}/admin/marketplace/remove_admin_products`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "include",
        method: "POST",
        body: JSON.stringify({
          id: removeId,
        }),
      },
    ).then(async (res) => {
      if (res.status === 200) {
        toast.success("Removed Successfully");
        setPostLoader(false);
        setShowRemoveDialog(false);
        setTriggerMarketPlace(!triggerMarketPlace);
      } else {
        const data = await res.json();
        toast.error(data.msg);
        setPostLoader(false);
        setShowRemoveDialog(false);
      }
    });
  };

  const duplicateHandlerClicked = (id) => {
    setShowDuplicateDialog(true);
    setDuplicateId(id);
  };

  const handleDuplicateData = async () => {
    setPostLoader(true);
    fetch(`${process.env.REACT_APP_SERVER_URL}/admin/marketplace/duplicate`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      method: "POST",
      body: JSON.stringify({
        id: duplicateId,
      }),
    }).then((res) => {
      if (res.status === 200) {
        toast.success("Duplicated Successfully");
        setPostLoader(false);
        setShowDuplicateDialog(false);
        setTriggerMarketPlace(!triggerMarketPlace);
      }
    });
  };

  const addCategory = async () => {
    const name = newCompany.trim();
    if (!name) return;
    const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/add_company`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ name: name }),
    });
    if (res.ok) {
      toast.success("Company added successfully");
      setTriggerMarketPlace(!triggerMarketPlace);
    } else {
      const err = await res.json();
      toast.error(err.message || "Failed to add company");
    }
    setNewCompany("");
    setOpenCompanyDrawer(false);
  };

  const handleCompanyChange = (event) => {
    setCompanyId(event.target.value);
  };

  const toggleFlag = async (item, flag) => {
    const nextValue = !item?.[flag];
    // Optimistic local update so the pill flips instantly
    setItems((prev) =>
      prev.map((it) => (it.id === item.id ? { ...it, [flag]: nextValue } : it)),
    );
    try {
      const res = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/admin/marketplace/toggle_flag`,
        {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: item.id, flag, value: nextValue }),
        },
      );
      if (!res.ok) {
        // Roll back on failure
        setItems((prev) =>
          prev.map((it) =>
            it.id === item.id ? { ...it, [flag]: !nextValue } : it,
          ),
        );
        toast.error("Failed to update");
        return;
      }
      const label = flag === "is_featured" ? "Featured" : "New Release";
      toast.success(`${label}: ${nextValue ? "ON" : "OFF"}`);
    } catch (err) {
      setItems((prev) =>
        prev.map((it) =>
          it.id === item.id ? { ...it, [flag]: !nextValue } : it,
        ),
      );
      toast.error("Network error");
    }
  };

  const addCategoryHandler = async () => {
    const trimmed = newCategory.trim();
    if (!trimmed) return;
    const res = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/add_category`,
      {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: trimmed }),
      },
    );
    if (res.ok) {
      const payload = await res.json().catch(() => null);
      const created = payload?.data;
      toast.success("Category added");
      if (created) {
        setCategories((prev) => [...prev, created]);
        setSelectedCategory(created);
      }
      setTriggerMarketPlace((v) => !v);
    } else {
      const err = await res.json().catch(() => ({}));
      toast.error(err.message || "Failed to add category");
    }
    setNewCategory("");
    setOpenCategoryDrawer(false);
  };

  const addSubCategoryHandler = async () => {
    const trimmed = newSubCategory.trim();
    const parent = newSubCategoryCat;
    if (!trimmed || !parent?.id) return;
    const res = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/add_subcategory`,
      {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: trimmed, category_id: { id: parent.id } }),
      },
    );
    if (res.ok) {
      const payload = await res.json().catch(() => null);
      const created = payload?.data;
      toast.success("Sub-category added");
      if (created) {
        setSubCategories((prev) => [...prev, created]);
        if (selectedCategory?.id === parent.id) setSelectedSubCategory(created);
      }
      setTriggerMarketPlace((v) => !v);
    } else {
      const err = await res.json().catch(() => ({}));
      toast.error(err.message || "Failed to add sub-category");
    }
    setNewSubCategory("");
    setNewSubCategoryCat(null);
    setOpenSubCategoryDrawer(false);
  };

  const categoryOptions = categories?.map((c) => ({
    value: c.id,
    label: c.name,
  }));
  const subCategoryOptions = subCategories
    ?.filter(
      (sc) => selectedCategory && sc.category_id === selectedCategory.id,
    )
    ?.map((sc) => ({ value: sc.id, label: sc.name }));

  return (
    <div className="w-full flex">
      {isAdmin(props.userRole) && (
        <>
          {Object.keys(selectedMarketPlace).length === 0 && (
            <>
              {marketPlaceLoader && (
                <CircularProgress
                  size={40}
                  className={styles.circularProgressMain}
                />
              )}
              {!marketPlaceLoader && (
                <div>
                  <div className={styles.mainContainer}>
                    <div className={styles.outerAddForm}>
                      <div className={styles.filterBox}>
                        <TextField
                          id="filled-basic"
                          type="text"
                          placeholder="Search by name"
                          value={searchQuery}
                          onChange={handleSearchChange}
                          sx={{ width: "25%" }}
                        />
                        <select
                          name="status"
                          className={styles.selectFilter}
                          value={paymentStatus}
                          onChange={handlePaymentStatusChange}
                        >
                          <option value="">All</option>
                          <option value="Active">Active</option>
                          <option value="Out Of Stock">Out Of Stock</option>
                          <option value="Inactive">Inactive</option>
                        </select>
                        <FormControl sx={{ width: "25%" }}>
                          <InputLabel
                            sx={{
                              display: "flex",
                              alignItems: "center",
                            }}
                            id="demo-multiple-name-label"
                          >
                            Company
                          </InputLabel>
                          <Select
                            label="Company"
                            value={companyId}
                            onChange={handleCompanyChange}
                            MenuProps={MenuProps}
                          >
                            <MenuItem key={-1} value={""}>
                              All
                            </MenuItem>
                            {companies?.map((c, i) => (
                              <MenuItem key={i} value={c.id}>
                                {c.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                      <button
                        className={styles.addForm}
                        onClick={addFormOpenHandler}
                      >
                        Add Product
                      </button>
                    </div>
                    <ul className={styles.ulContainer}>
                      {filteredAppsData &&
                        filteredAppsData.map((item) => (
                          <li key={item.id}>
                            <div
                              className={styles.cardContainer}
                              onClick={() => handleSelectMarketPlace(item)}
                            >
                              <div className={styles.bodyContainer}>
                                <div className={styles.imageContainer}>
                                  <Image
                                    className={styles.image}
                                    src={item.logoLink}
                                    alt={item.name}
                                    borderRadius="lg"
                                  />
                                  <h1
                                    className={
                                      item.status === "Active"
                                        ? styles.active
                                        : item.status === "Out Of Stock"
                                          ? styles.outofstock
                                          : styles.inactive
                                    }
                                  >
                                    {item.status}
                                  </h1>
                                </div>
                                <div className={styles.dataContainer}>
                                  <Heading className={styles.productName}>
                                    {item.name}
                                  </Heading>
                                  <Text className={styles.descriptionContainer}>
                                    {item.info ? (
                                      <div
                                        onClick={() =>
                                          handleSelectMarketPlace(item)
                                        }
                                      >
                                        <ReadMoreReadLess
                                          charLimit={100}
                                          readMoreText="Read More"
                                          readLessText="Read Less"
                                        >
                                          {item.info}
                                        </ReadMoreReadLess>
                                      </div>
                                    ) : (
                                      <Text>No information available</Text>
                                    )}
                                  </Text>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: "6px",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        toggleFlag(item, "is_featured");
                                      }}
                                      style={{
                                        fontSize: "11px",
                                        fontWeight: 600,
                                        padding: "4px 10px",
                                        borderRadius: "999px",
                                        border: item.is_featured
                                          ? "1px solid #f59e0b"
                                          : "1px solid #cbd5e1",
                                        background: item.is_featured
                                          ? "#fffbeb"
                                          : "#ffffff",
                                        color: item.is_featured
                                          ? "#b45309"
                                          : "#475569",
                                        cursor: "pointer",
                                        transition: "all 0.15s ease",
                                      }}
                                      title={
                                        item.is_featured
                                          ? "Click to remove from Featured"
                                          : "Click to mark as Featured"
                                      }
                                    >
                                      ★ {item.is_featured ? "Featured" : "Mark Featured"}
                                    </button>
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        toggleFlag(item, "is_new");
                                      }}
                                      style={{
                                        fontSize: "11px",
                                        fontWeight: 600,
                                        padding: "4px 10px",
                                        borderRadius: "999px",
                                        border: item.is_new
                                          ? "1px solid #16a34a"
                                          : "1px solid #cbd5e1",
                                        background: item.is_new
                                          ? "#f0fdf4"
                                          : "#ffffff",
                                        color: item.is_new
                                          ? "#15803d"
                                          : "#475569",
                                        cursor: "pointer",
                                        transition: "all 0.15s ease",
                                      }}
                                      title={
                                        item.is_new
                                          ? "Click to remove from New Releases"
                                          : "Click to mark as New Release"
                                      }
                                    >
                                      {item.is_new ? "New Release" : "Mark New"}
                                    </button>
                                  </div>
                                  <div className={styles.buttonGroup}>
                                    <button
                                      className={styles.editButton}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        editFormOpenHandler(item);
                                      }}
                                    >
                                      Edit
                                    </button>
                                    <button
                                      className={styles.removeButton}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        removeHandlerClicked(item.id);
                                      }}
                                    >
                                      Remove
                                    </button>
                                    <button
                                      className={styles.duplicateButton}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        duplicateHandlerClicked(item.id);
                                      }}
                                    >
                                      Duplicate
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
              )}

              {/* ADD FORM DIALOG MODAL */}
              {showAddForm && (
                <>
                  <div
                    className={styles.backdrop}
                    onClick={addFormCloseHandler}
                  ></div>
                  <div className={styles.modalContainer}>
                    <h2 className={styles.marketPlaceHeading}>
                      Add Marketplace Details
                    </h2>
                    <Form className={styles.mainForm}>
                      <Form.Group className={styles.formGroup}>
                        <Form.Label>Name</Form.Label>
                        {/* Modern combobox: search existing SKUs (incl.
                            vendor-owned the admin can add admin-pricing to) or
                            create a new admin-owned product. Endpoints/payloads
                            unchanged — same handler side-effects as before. */}
                        <ReactSelect
                          inputValue={search}
                          onInputChange={(val, meta) => {
                            if (meta.action === "input-change") {
                              setSearch(val);
                              setIsExisting(false);
                              setName("");
                              setSelectedCompany("");
                              setLogoLink("");
                              setInfo("");
                              setTags("");
                            }
                          }}
                          value={
                            isExisting && skuId != null
                              ? { value: skuId, label: name }
                              : null
                          }
                          options={createItems.map((item) => ({
                            value: item.id,
                            label: item.name,
                            item,
                            isDisabled: disabledItems.includes(item.id),
                          }))}
                          getOptionLabel={(o) =>
                            disabledItems.includes(o.value)
                              ? `${o.label} — You have this SKU already created`
                              : o.label
                          }
                          onChange={(option) => {
                            if (!option) {
                              setIsExisting(false);
                              setSkuId(null);
                              setName("");
                              setSearch("");
                              return;
                            }
                            const item = option.item;
                            setIsExisting(true);
                            setSkuId(item.id);
                            setSearch(item.name ?? "");
                            setName(item.name ?? "");
                            setSelectedCompany(item.company_id ?? "");
                            setLogoLink(item.logoLink ?? "");
                            setInfo(item.info ?? "");
                            setTags(tagString(item.type2));
                            setVendorName(item.vendor_name);
                            setMainEmail(item.main_email);
                            setBillingEmail(item.billing_email);
                            setBillingType(item.billing_type);
                            setNetPayment(item.net_payment);
                            setStatus(item.status);
                            setStartDate(formatDate(item.start_date));
                          }}
                          placeholder="Search existing products…"
                          isClearable
                          classNamePrefix="mp-combobox"
                          menuPortalTarget={
                            typeof document !== "undefined"
                              ? document.body
                              : null
                          }
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 4000 }),
                          }}
                        />
                        {errors.name && !name && (
                          <span className={styles.error}>{errors.name}</span>
                        )}
                        {search && !isExisting && (
                          <button
                            type="button"
                            className={styles.dropdownItemCreate}
                            onClick={() => {
                              setIsExisting(false);
                              setName(search);
                              setSelectedCompany("");
                              setLogoLink("");
                              setInfo("");
                              setTags("");
                            }}
                          >
                            ➕ Create new "{search}" (admin-owned)
                          </button>
                        )}
                        {isExisting && (
                          <span className={styles.alreadyExists}>
                            Adding admin pricing to the selected SKU
                          </span>
                        )}
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Company</Form.Label>
                        <Form.Control
                          required
                          as="select"
                          value={selectedCompany}
                          disabled={isExisting}
                          onChange={(e) => setSelectedCompany(e.target.value)}
                          className={styles.formControl} // Ensure this class is applied
                        >
                          <option value="">--Select--</option>
                          {companies.map((c, i) => (
                            <option key={i} value={c.id}>
                              {c.name}
                            </option>
                          ))}
                        </Form.Control>
                        <button
                          style={{
                            marginTop: "2%",
                            cursor: isExisting ? "not-allowed" : "pointer",
                            opacity: isExisting ? 0.6 : 1,
                          }}
                          type="button"
                          disabled={isExisting}
                          onClick={() => setOpenCompanyDrawer(true)}
                        >
                          + Add
                        </button>
                      </Form.Group>
                      <Form.Group className={styles.formGroup}>
                        <Form.Label>Category</Form.Label>
                        <ReactSelect
                          options={categoryOptions}
                          value={
                            selectedCategory
                              ? {
                                  value: selectedCategory.id,
                                  label: selectedCategory.name,
                                }
                              : null
                          }
                          onChange={(option) => {
                            const cat =
                              categories.find((c) => c.id === option.value) ||
                              null;
                            setSelectedCategory(cat);
                            setSelectedSubCategory(null);
                          }}
                          isDisabled={isExisting}
                          placeholder="Select Category"
                        />
                        <button
                          style={{
                            marginTop: "2%",
                            cursor: isExisting ? "not-allowed" : "pointer",
                            opacity: isExisting ? 0.6 : 1,
                          }}
                          type="button"
                          disabled={isExisting}
                          onClick={() => setOpenCategoryDrawer(true)}
                        >
                          + Add
                        </button>
                      </Form.Group>
                      <Form.Group className={styles.formGroup}>
                        <Form.Label>Sub Category</Form.Label>
                        <ReactSelect
                          options={subCategoryOptions}
                          value={
                            selectedSubCategory
                              ? {
                                  value: selectedSubCategory.id,
                                  label: selectedSubCategory.name,
                                }
                              : null
                          }
                          onChange={(option) => {
                            const sub =
                              subCategories.find(
                                (s) => s.id === option.value,
                              ) || null;
                            setSelectedSubCategory(sub);
                          }}
                          isDisabled={isExisting || !selectedCategory}
                          placeholder="Select Sub Category"
                          noOptionsMessage={() =>
                            selectedCategory
                              ? "No sub-categories"
                              : "Select a category first"
                          }
                        />
                        <button
                          style={{
                            marginTop: "2%",
                            cursor:
                              isExisting || !selectedCategory
                                ? "not-allowed"
                                : "pointer",
                            opacity:
                              isExisting || !selectedCategory ? 0.6 : 1,
                          }}
                          type="button"
                          disabled={isExisting || !selectedCategory}
                          onClick={() => {
                            setNewSubCategoryCat(selectedCategory);
                            setOpenSubCategoryDrawer(true);
                          }}
                        >
                          + Add
                        </button>
                      </Form.Group>
                      <Form.Group
                        controlId="formName"
                        className={styles.formGroup}
                      >
                        <Form.Label>Image Link</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          value={logoLink}
                          disabled={isExisting}
                          onChange={(e) => setLogoLink(e.target.value)}
                          placeholder="Enter Image Link"
                          className={styles.formControl}
                        />
                        {errors.logoLink && !logoLink && (
                          <span className={styles.error}>
                            {errors.logoLink}
                          </span>
                        )}
                      </Form.Group>
                      <Form.Group
                        controlId="formName"
                        className={styles.formGroup}
                      >
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          value={info}
                          disabled={isExisting}
                          onChange={(e) => setInfo(e.target.value)}
                          placeholder="Enter Description"
                          className={styles.formControl} // Ensure this class is applied
                        />
                        {errors.info && !info && (
                          <span className={styles.error}>{errors.info}</span>
                        )}
                      </Form.Group>
                      <Form.Group
                        controlId="formStartDate"
                        className={styles.formGroup}
                      >
                        <Form.Label>
                          Tags (Write all tags comma(,) seperated)
                        </Form.Label>
                        <Form.Control
                          required
                          type="text"
                          disabled={isExisting}
                          value={tags}
                          onChange={(e) => setTags(e.target.value)}
                          className={styles.formControl} // Ensure this class is applied
                        />
                        {errors.tags && !tags && (
                          <span className={styles.error}>{errors.tags}</span>
                        )}
                      </Form.Group>
                      <Form.Group
                        controlId="formStatus"
                        className={styles.formGroup}
                      >
                        <Form.Label>Status</Form.Label>
                        <Form.Control
                          required
                          disabled={isExisting}
                          as="select"
                          value={status}
                          onChange={(e) => setStatus(e.target.value)}
                          className={styles.formControl}
                        >
                          <option value="Active">Active</option>
                          <option value="Out Of Stock">Out of Stock</option>
                          <option value="Inactive">Inactive</option>
                        </Form.Control>
                      </Form.Group>
                      <Form.Group className={styles.formGroup}>
                        <Form.Label>
                          Popularity boost (0–100) — admin curation, 30% of
                          customer popularity sort
                        </Form.Label>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 12,
                          }}
                        >
                          <input
                            type="range"
                            min={0}
                            max={100}
                            step={1}
                            value={adminPopularityBoost}
                            disabled={isExisting}
                            onChange={(e) =>
                              setAdminPopularityBoost(Number(e.target.value))
                            }
                            style={{ flex: 1, accentColor: "#1a9aea" }}
                          />
                          <input
                            type="number"
                            min={0}
                            max={100}
                            value={adminPopularityBoost}
                            disabled={isExisting}
                            onChange={(e) => {
                              const v = Math.max(
                                0,
                                Math.min(100, Number(e.target.value) || 0),
                              );
                              setAdminPopularityBoost(v);
                            }}
                            style={{
                              width: 70,
                              padding: "6px 8px",
                              border: "1px solid #cbd5e1",
                              borderRadius: 6,
                              textAlign: "center",
                            }}
                          />
                        </div>
                      </Form.Group>
                      <button
                        onClick={handleSubmit}
                        variant="primary"
                        type="submit"
                        className={styles.submitButton}
                      >
                        {addFormSubmitLoader ? (
                          <CircularProgress size={20} sx={{ color: "white" }} />
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </Form>
                  </div>{" "}
                </>
              )}

              {/* EDIT FORM DIALOG */}
              {showEditForm && (
                <>
                  {" "}
                  <div
                    className={styles.backdrop}
                    onClick={editFormCloseHandler}
                  ></div>
                  <div className={styles.modalContainer}>
                    <Form className={styles.mainForm}>
                      <h2 className={styles.marketPlaceHeading}>
                        Edit MarketPlace Details
                      </h2>
                      {itemVendorId !== adminVendorId && (
                        <p style={{ color: "red" }}>
                          *Can only be edited by product owner
                        </p>
                      )}
                      <Form.Group
                        controlId="formName"
                        className={styles.formGroup}
                      >
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          value={name}
                          disabled={itemVendorId !== adminVendorId}
                          onChange={(e) => setName(e.target.value)}
                          placeholder="Enter name"
                          className={styles.formControl} // Ensure this class is applied
                        />
                        {errors.name && !name && (
                          <span className={styles.error}>{errors.name}</span>
                        )}
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Company</Form.Label>
                        <Form.Control
                          required
                          as="select"
                          disabled={itemVendorId !== adminVendorId}
                          value={selectedCompany}
                          onChange={(e) => setSelectedCompany(e.target.value)}
                          className={styles.formControl} // Ensure this class is applied
                        >
                          <option value="">--Select--</option>
                          {companies.map((c, i) => (
                            <option key={i} value={c.id}>
                              {c.name}
                            </option>
                          ))}
                        </Form.Control>
                        <button
                          style={{ marginTop: "2%" }}
                          disabled={itemVendorId !== adminVendorId}
                          type="button"
                          onClick={() => setOpenCompanyDrawer(true)}
                        >
                          + Add
                        </button>
                      </Form.Group>
                      <Form.Group className={styles.formGroup}>
                        <Form.Label>Category</Form.Label>
                        <ReactSelect
                          options={categoryOptions}
                          value={
                            selectedCategory
                              ? {
                                  value: selectedCategory.id,
                                  label: selectedCategory.name,
                                }
                              : null
                          }
                          onChange={(option) => {
                            const cat =
                              categories.find((c) => c.id === option.value) ||
                              null;
                            setSelectedCategory(cat);
                            setSelectedSubCategory(null);
                          }}
                          isDisabled={itemVendorId !== adminVendorId}
                          placeholder="Select Category"
                        />
                        <button
                          style={{ marginTop: "2%" }}
                          disabled={itemVendorId !== adminVendorId}
                          type="button"
                          onClick={() => setOpenCategoryDrawer(true)}
                        >
                          + Add
                        </button>
                      </Form.Group>
                      <Form.Group className={styles.formGroup}>
                        <Form.Label>Sub Category</Form.Label>
                        <ReactSelect
                          options={subCategoryOptions}
                          value={
                            selectedSubCategory
                              ? {
                                  value: selectedSubCategory.id,
                                  label: selectedSubCategory.name,
                                }
                              : null
                          }
                          onChange={(option) => {
                            const sub =
                              subCategories.find(
                                (s) => s.id === option.value,
                              ) || null;
                            setSelectedSubCategory(sub);
                          }}
                          isDisabled={
                            itemVendorId !== adminVendorId || !selectedCategory
                          }
                          placeholder="Select Sub Category"
                          noOptionsMessage={() =>
                            selectedCategory
                              ? "No sub-categories"
                              : "Select a category first"
                          }
                        />
                        <button
                          style={{ marginTop: "2%" }}
                          disabled={
                            itemVendorId !== adminVendorId || !selectedCategory
                          }
                          type="button"
                          onClick={() => {
                            setNewSubCategoryCat(selectedCategory);
                            setOpenSubCategoryDrawer(true);
                          }}
                        >
                          + Add
                        </button>
                      </Form.Group>
                      <Form.Group
                        controlId="formName"
                        className={styles.formGroup}
                      >
                        <Form.Label>Image URL</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          disabled={itemVendorId !== adminVendorId}
                          value={logoLink}
                          onChange={(e) => setLogoLink(e.target.value)}
                          placeholder="Enter Link to Image"
                          className={styles.formControl} // Ensure this class is applied
                        />
                        {errors.logoLink && !logoLink && (
                          <span className={styles.error}>
                            {errors.logoLink}
                          </span>
                        )}
                      </Form.Group>
                      <Form.Group
                        controlId="formName"
                        className={styles.formGroup}
                      >
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          disabled={itemVendorId !== adminVendorId}
                          value={info}
                          onChange={(e) => setInfo(e.target.value)}
                          placeholder="Enter Description"
                          className={styles.formControl} // Ensure this class is applied
                        />
                        {errors.info && !info && (
                          <span className={styles.error}>{errors.info}</span>
                        )}
                      </Form.Group>
                      <Form.Group
                        controlId="formStartDate"
                        className={styles.formGroup}
                      >
                        <Form.Label>
                          Tags (Write all tags comma(,) seperated)
                        </Form.Label>
                        <Form.Control
                          required
                          type="text"
                          disabled={itemVendorId !== adminVendorId}
                          value={tags}
                          onChange={(e) => setTags(e.target.value)}
                          className={styles.formControl} // Ensure this class is applied
                        />
                        {errors.tags && !tags && (
                          <span className={styles.error}>{errors.tags}</span>
                        )}
                      </Form.Group>
                      <Form.Group
                        controlId="formStatus"
                        className={styles.formGroup}
                      >
                        <Form.Label>Status</Form.Label>
                        <Form.Control
                          required
                          as="select"
                          value={status}
                          disabled={itemVendorId !== adminVendorId}
                          onChange={(e) => setStatus(e.target.value)}
                          className={styles.formControl} // Ensure this class is applied
                        >
                          <option value="Active">Active</option>
                          <option value="Out Of Stock">Out of Stock</option>
                          <option value="Inactive">Inactive</option>
                        </Form.Control>
                      </Form.Group>
                      <Form.Group className={styles.formGroup}>
                        <Form.Label>
                          Popularity boost (0–100) — admin curation, 30% of
                          customer popularity sort
                        </Form.Label>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 12,
                          }}
                        >
                          <input
                            type="range"
                            min={0}
                            max={100}
                            step={1}
                            value={adminPopularityBoost}
                            disabled={itemVendorId !== adminVendorId}
                            onChange={(e) =>
                              setAdminPopularityBoost(Number(e.target.value))
                            }
                            style={{ flex: 1, accentColor: "#1a9aea" }}
                          />
                          <input
                            type="number"
                            min={0}
                            max={100}
                            value={adminPopularityBoost}
                            disabled={itemVendorId !== adminVendorId}
                            onChange={(e) => {
                              const v = Math.max(
                                0,
                                Math.min(100, Number(e.target.value) || 0),
                              );
                              setAdminPopularityBoost(v);
                            }}
                            style={{
                              width: 70,
                              padding: "6px 8px",
                              border: "1px solid #cbd5e1",
                              borderRadius: 6,
                              textAlign: "center",
                            }}
                          />
                        </div>
                      </Form.Group>
                      <button
                        variant="primary"
                        type="submit"
                        className={styles.submitButton}
                        onClick={editSubmitHandler}
                      >
                        {editSubmitLoader ? (
                          <CircularProgress size={20} sx={{ color: "white" }} />
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </Form>
                  </div>{" "}
                </>
              )}
            </>
          )}
          {Object.keys(selectedMarketPlace).length !== 0 && (
            <MarketPlaceDetails
              selectedMarketPlace={selectedMarketPlace}
              setSelectedMarketPlace={setSelectedMarketPlace}
            />
          )}

          <DynamicDialog
            isOpen={showRemoveDialog}
            onClose={() => setShowRemoveDialog(false)}
            title="Are you sure you want to Delete (All Child Data Will Be Lost)?"
            title2=""
            description={[]}
            Loader={postLoader}
            fields={[]}
            buttons={[
              {
                label: "Cancel",
                onClick: () => setShowRemoveDialog(false),
              },
              {
                label: "Delete",
                onClick: () => {
                  handleRemoveInvite();
                },
              },
            ]}
          />

          <DynamicDialog
            isOpen={showDuplicateDialog}
            onClose={() => setShowDuplicateDialog(false)}
            title="Are you sure you want to Duplicate (All Child Data Will Be Duplicated)?"
            title2=""
            description={[]}
            Loader={postLoader}
            fields={[]}
            buttons={[
              {
                label: "Cancel",
                onClick: () => setShowDuplicateDialog(false),
              },
              {
                label: "Confirm",
                onClick: () => {
                  handleDuplicateData();
                },
              },
            ]}
          />

          <Drawer
            anchor="right"
            open={openCompanyDrawer}
            onClose={() => setOpenCompanyDrawer(false)}
            sx={{ width: "50%" }}
          >
            <Box sx={{ width: 340, p: 2 }} role="presentation">
              <Typography variant="h6" sx={{ mb: 1 }}>
                Add Company
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <TextField
                label="Company Name"
                fullWidth
                value={newCompany}
                onChange={(e) => setNewCompany(e.target.value)}
                autoFocus
              />
              <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
                <Button variant="contained" onClick={addCategory}>
                  Save
                </Button>
                <Button onClick={() => setOpenCompanyDrawer(false)}>
                  Cancel
                </Button>
              </Box>
            </Box>
          </Drawer>

          <Drawer
            anchor="right"
            open={openCategoryDrawer}
            onClose={() => setOpenCategoryDrawer(false)}
            sx={{ width: "50%" }}
          >
            <Box sx={{ width: 340, p: 2 }} role="presentation">
              <Typography variant="h6" sx={{ mb: 1 }}>
                Add Category
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <TextField
                label="Category Name"
                fullWidth
                value={newCategory}
                onChange={(e) => setNewCategory(e.target.value)}
                autoFocus
              />
              <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
                <Button variant="contained" onClick={addCategoryHandler}>
                  Save
                </Button>
                <Button onClick={() => setOpenCategoryDrawer(false)}>
                  Cancel
                </Button>
              </Box>
            </Box>
          </Drawer>

          <Drawer
            anchor="right"
            open={openSubCategoryDrawer}
            onClose={() => setOpenSubCategoryDrawer(false)}
            sx={{ width: "50%" }}
          >
            <Box sx={{ width: 340, p: 2 }} role="presentation">
              <Typography variant="h6" sx={{ mb: 1 }}>
                Add Sub Category
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <TextField
                label="Sub Category Name"
                fullWidth
                value={newSubCategory}
                onChange={(e) => setNewSubCategory(e.target.value)}
              />
              <div style={{ marginTop: 12 }}>
                <ReactSelect
                  options={categoryOptions}
                  value={
                    newSubCategoryCat
                      ? {
                          value: newSubCategoryCat.id,
                          label: newSubCategoryCat.name,
                        }
                      : null
                  }
                  onChange={(option) => {
                    const cat =
                      categories.find((c) => c.id === option.value) || null;
                    setNewSubCategoryCat(cat);
                  }}
                  placeholder="Select Category"
                />
              </div>
              <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
                <Button variant="contained" onClick={addSubCategoryHandler}>
                  Save
                </Button>
                <Button onClick={() => setOpenSubCategoryDrawer(false)}>
                  Cancel
                </Button>
              </Box>
            </Box>
          </Drawer>
        </>
      )}
    </div>
  );
}

export default AdminProducts;
